import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { environment } from 'src/environments/environment';

export interface MemberTemplate {
  templateName: string,
  name: string,
  description: string,
}

@Component({
  selector: 'app-member-keywords',
  templateUrl: './member-keywords.component.html',
  styleUrls: ['./member-keywords.component.scss']
})
export class MemberKeywordsComponent implements OnInit {

  constructor(
    private modalService: NgbModal,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private local: LocalServiceService,
    private customerService: CustomerService
  ) { }

  keywords: any = []
  imgUrl: string = environment.ImageUrl
  listStatus: any = [
    'No',
    'Popular',
  ]

  ngOnInit(): void {
    this.initData()
  }

  initData() {
    this.customerService.popularMemberShopKeyword(1).subscribe((response: any) => {
      this.keywords = response.body
    })
  }

  handleApproval(event: any, item: any) {
    const status = event.target.value
    this.local.alertConfirm({
      message: 'Are you sure you want to change the popular status?'
    }).then((resp) => {
      if (resp.isConfirmed) {
        this.customerService.popularMemberShopKeywordChangeStatus({
          id: item.id,
          isPopular: status
        }).subscribe((response: any) => {
          this.toastr.success(response.message)
          this.initData()
        }, (e) => {
          this.toastr.error("Failed")
          this.initData()
        })
      }
    })
  }

  handleDelete(item: any) {
    this.local.alertConfirm({}).then((resp) => {
      if (resp.isConfirmed) {
        this.auth.addMemberShopKeyword({
          textDelete: item.text,
        }).subscribe((response: any) => {
          this.toastr.success(response.message)
          this.initData()
        }, (e) => {
          this.toastr.error("Failed")
          this.initData()
        })
      }
    })
  }
}
